import * as _actions from './actions';
import _reducer from './reducer';
import _onlineUsage from './model';
import create from './create';

_onlineUsage.create = create;

export const OnlineUsage = _onlineUsage;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/OnlineUsage/index.js